import gql from 'graphql-tag';

export const AB_TEST_QUERY = gql`
    query getABTests {
        abTests {
            id
            name
        }
    }
`;
